module.exports = __webpack_public_path__ + "static/media/google_logo.1f85ef8e.svg";